import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, Eye, Users, TrendingUp, ArrowRight } from "lucide-react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { api } from "@/lib/api";

function Stat({ icon: Icon, label, value, to }) {
  return (
    <Link to={to} className="bg-card border border-border rounded-xl p-5 hover:border-primary transition-colors group">
      <div className="flex items-center justify-between">
        <div className="h-10 w-10 rounded-lg bg-accent text-primary flex items-center justify-center"><Icon size={20} /></div>
        <ArrowRight size={16} className="text-ink/30 group-hover:text-primary" />
      </div>
      <p className="mt-4 font-heading text-3xl font-black text-ink">{value}</p>
      <p className="text-sm text-ink/50">{label}</p>
    </Link>
  );
}

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics/overview").then((r) => setD(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-black text-ink">Tableau de bord</h1>
      <p className="text-ink/50 mt-1">Vue d'ensemble de l'activité du site.</p>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Inbox} label="Leads reçus" value={d?.leads_total ?? "—"} to="/admin/leads" />
        <Stat icon={Inbox} label="Leads à traiter" value={d?.leads_new ?? "—"} to="/admin/leads" />
        <Stat icon={Eye} label="Pages vues (total)" value={d?.total_views ?? "—"} to="/admin/analytics" />
        <Stat icon={Users} label="Visiteurs uniques" value={d?.unique_sessions ?? "—"} to="/admin/analytics" />
      </div>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-card border border-border rounded-xl p-5">
          <h2 className="font-heading font-bold text-ink mb-4 flex items-center gap-2"><TrendingUp size={18} className="text-primary" /> Trafic — 14 derniers jours</h2>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={d?.series || []}>
                <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#F39200" stopOpacity={0.4} /><stop offset="100%" stopColor="#F39200" stopOpacity={0} /></linearGradient></defs>
                <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={(v) => v?.slice(5)} />
                <YAxis tick={{ fontSize: 11 }} width={30} />
                <Tooltip />
                <Area type="monotone" dataKey="views" stroke="#F39200" strokeWidth={2} fill="url(#g)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5">
          <h2 className="font-heading font-bold text-ink mb-4">Pages les plus visitées</h2>
          <ul className="space-y-2">
            {(d?.top_pages || []).map((p) => (
              <li key={p.path} className="flex items-center justify-between text-sm border-b border-border/60 pb-2">
                <span className="text-ink/70 truncate">{p.path}</span>
                <span className="font-bold text-ink">{p.views}</span>
              </li>
            ))}
            {!d?.top_pages?.length && <li className="text-ink/40 text-sm">Aucune donnée</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
